import { INotificationService } from "./interfaces";
import { injectable } from 'inversify';
import { Subject } from 'rxjs';
import { ToasterModel } from '../common/model/ToasterModel';
import { SnackbarModel } from '../common/model/SnabarModel';
import { EErrorType } from "../common/enum/EErrorType";
import { EComponentName } from "../common/enum/EComponentName";

@injectable()
export default class NotificationService implements INotificationService {

    progressNotification: Subject<any> = new Subject<any>();
    tosterNotification: Subject<any> = new Subject<any>();

    snackbarNotification: Subject<any> = new Subject<any>();

    snackbarNotificationClose: Subject<any> = new Subject<any>();

    notifyProgressSpinner(isActive: boolean) {
        this.progressNotification.next(isActive);
    }

    notifyToster(message: string, errorType: EErrorType) {
        let toasterObj: ToasterModel = new ToasterModel();
        toasterObj.Type = errorType;
        toasterObj.Message = message

        this.tosterNotification.next(toasterObj);
    }

    notifySnackbar(message: string, name: EComponentName) {
        let snackbarObj: SnackbarModel = new SnackbarModel();
        snackbarObj.Message = message;
        snackbarObj.Name = name;

        this.snackbarNotification.next(snackbarObj);
    }

    notifySnackbarClose() {
        this.snackbarNotificationClose.next();
    }
}